// @ts-nocheck
import {Column} from 'react-table'
import {CompanyInfoCell} from './CompanyInfoCell'
import {CompanyActionsCell} from './CompanyActionsCell'
import {CompanySelectionCell} from './CompanySelectionCell'
import {CompanyCustomHeader} from './CompnayCustomHeader'
import {CompanyJoinedCell} from './CompanyJoinedCell'
import {User} from '../../core/_models'
import { CompanyStatusCell } from './CompanyStatusCell'

const usersColumns: ReadonlyArray<Column<User>> = [
  
  {
    Header: (props) => <CompanyCustomHeader tableProps={props} title='Name' className='min-w-125px' />,
    id: 'name',
    Cell: ({...props}) => <CompanyInfoCell user={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <CompanyCustomHeader tableProps={props} title='Slug' className='min-w-125px' />
    ),
    accessor: 'slug',
  },
  // {
  //   Header: (props) => <CompanyCustomHeader tableProps={props} title='Role' className='min-w-125px' />,
  //   accessor: 'role',
  // },
  // { id : 'status',
  //   Header: (props) => <CompanyCustomHeader tableProps={props} title='Status' className='min-w-125px' />,
  //   accessor: d => d.status ? 'Enable': 'Disable',
  //   Cell: ({...props}) => <CompanyStatusCell user={props.data[props.row.index]} />,
  // },

  {
    Header: (props) => (
      <CompanyCustomHeader tableProps={props} title='Joined day' className='min-w-125px' />
    ),
    id: 'createdAt',
    Cell: ({...props}) => <CompanyJoinedCell user={props.data[props.row.index]} />,
  },
  
  {
    Header: (props) => (
      <CompanyCustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({...props}) => <CompanyActionsCell id={props.data[props.row.index].id} status={props.data[props.row.index].status} 
    user={props.data[props.row.index]}
    />,
  },

  
]

export {usersColumns}
